<template>
  <!-- 设置弹层-->
  <el-dialog title="修改密码"
             :visible.sync="visible"
             @open="init"
             @close="doClose"
             :append-to-body="true"
             :destroy-on-close="true"
             :modal-append-to-body="true"
             :close-on-click-modal="false"
             width="500px">
    <el-form :model="passwordInfo" :rules="rules" ref="passwordForm" label-width="90px" size="medium">
      <el-form-item label="旧密码" prop="password">
        <el-input type="password" v-model="passwordInfo.password" placeholder="请输入旧密码"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input type="password" v-model="passwordInfo.newPassword" placeholder="请输入新密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="cfmPassword">
        <el-input type="password" v-model="passwordInfo.cfmPassword" placeholder="请确认密码"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
				<el-button @click="doClose" size="medium"><i class="fa fa-close"></i> 关闭</el-button>
				<el-button type="primary" @click="submit" size="medium"><i class="fa fa-save"></i> 确定</el-button>
			</span>
  </el-dialog>
</template>

<script>
import {editPassword} from "@api/system/user";
import {mapGetters} from "vuex";

export default {
  name: 'edit-pwd',
  props: {
    visible: false
  },
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {
      passwordInfo: {
        password: '',
        newPassword: '',
        cfmPassword: ''
      },
      rules: {
        password: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        cfmPassword: [{ required: true, message: '请确认密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    init() {
    },
    doClose() {
      this.$emit('done', false)
    },
    submit() {
      this.$refs['passwordForm'].validate(valid => {
        if (valid) {
          let info = this.passwordInfo
          if (info.newPassword !== info.cfmPassword) {
            this.$message.error('确认密码与新密码不一致')
          } else {
            let query = {
              userId: this.user.id,
              param: info
            }
            editPassword(query).then(res => {
              if (res.data.code === 200) {
                this.$store.dispatch('clearToken')
                this.$router.push('/login')
                this.$message.success('密码修改成功')
                this.$emit('done', true)
              } else {
                this.$message.error(res.data.message)
              }
            })
          }
        }
      })
    },
  }
}
</script>

